export const ENV_NAME = process.env.REACT_APP_ENV_NAME || "development";
export const ASSET_IMAGES = process.env.REACT_APP_IMAGES_PATH;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const ASSET_AVATARS = ASSET_IMAGES + "/avatar";
export const ASSET_LOGOS = ASSET_IMAGES + "/logos";
export const USE_IMAGE_PLACEHOLDERS = false;
export const HOST = process.env.REACT_APP_HOST || "http://localhost:3000";
export const API_HOST = process.env.REACT_APP_API_HOST || "http://localhost:3000/api/v1";
// console.log("API_HOST", API_HOST)
